<template>
  <div>
    <vs-row>
      <vs-col>
        <vs-card class="cardx">
          <div slot="header" style="padding:10px">
            <h3>
              Routes report
            </h3>
          </div>
          <div>
            <vs-row>
              <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                <div class="mb-3" style="width:300px;display:inline-block;margin-right:10px;">
                  <label class="vs-input--label">Zone</label>
                  <v-select
                    @input="filters.page=1"
                    v-model="filters.zone_id"
                    :clearable="false"
                    :options="zones"
                    :reduce="el => el.id" label="name"  />
                </div>
                <div class="mb-3" style="display:inline-block;vertical-align:middle;" v-if="!config.routes.billing.enable">
                  <vs-dropdown class="mr-2 mt-2"  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>From</b>: {{since}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.since" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <vs-dropdown class="mr-2 "  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>To</b>: {{until}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQuery" calendar-class="border-none" :inline="true" v-model="dates.until" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

                <div class="mb-3" style="display:inline-block;vertical-align:middle;" v-if="config.routes.billing.enable">
                  <vs-dropdown class="mr-2 mt-2"  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>From week start</b>: {{since}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQueryWeekly_from" calendar-class="border-none" :inline="true" v-model="dates.since" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>

                  <vs-dropdown class="mr-2 "  vs-custom-content vs-trigger-click vs-drop-right :vs-dropdown-visible="true" >
                    <vs-chip transparent color="primary" style="min-width: 130px;">
                      <b>To week end:</b>: {{until}}
                    </vs-chip>
                    <vs-dropdown-menu class="loginx">
                      <datepicker @input="updateDateQueryWeekly_to" calendar-class="border-none" :inline="true" v-model="dates.until" format="yyyy-MM-dd"></datepicker>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>

              </vs-col>
              <vs-col vs-lg="4" vs-sm="4" vs-xs="4" style="vertical-align:middle;">
                <div style="text-align: right; vertical-align:middle;">
                  <vs-button class="mr-3 mb-3" @click="download_weekly" color="primary" type="filled" v-if="config.routes.billing.enable">Download</vs-button>
                  <vs-button class="mr-3 mb-3" @click="download" color="primary" type="filled" v-else>Download</vs-button>
                </div>
              </vs-col>
            </vs-row>


            <div  v-if="report">
              <vs-table
                stripe
                :data="report.routes">
                <template slot="thead">
                  <vs-th>
                    Route
                  </vs-th>
                  <vs-th>
                    Trips
                  </vs-th>
                  <vs-th>
                    Distance
                  </vs-th>
                  <vs-th v-if="config.routes.billing.enable">
                    Unit price
                  </vs-th>
                  <vs-th v-if="config.routes.billing.enable">
                    Total
                  </vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="'row'+index" v-for="(item,index) in data">
                    <vs-td >
                      {{item.route}}
                    </vs-td>
                    <vs-td>
                      {{item.trips}}
                    </vs-td>
                    <vs-td>
                      {{item.distance}}
                    </vs-td>
                    <vs-td v-if="config.routes.billing.enable">
                      {{item.price}}
                    </vs-td>
                    <vs-td v-if="config.routes.billing.enable">
                      {{item.total}}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>

              <div class="mt-3 mb-3">
                <span style="float:left;">
                  <vs-select
                    @input="filters.page=1"
                    class=""
                    label=""
                    v-model="filters.limit"
                    width="100px"
                    size="small"

                  >
                    <vs-select-item :key="'lim-'+index" :value="item.value" :text="item.text" v-for="(item,index) in limitOptions" />
                  </vs-select>
                </span>
                <pagination :last-page="report.pagination.pages" v-model="filters.page" />
              </div>
            </div>


          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker';
  import { CalendarIcon } from 'vue-feather-icons'
  const FileDownload = require('js-file-download');
  import limitOptions from "../../../constants/limit";

  export default {
    name: "RouteReport",
    components: {
      Datepicker,
      CalendarIcon
    },
    data(){
      return {
        filters: {},
        dates : {
          page: 0,
          since: moment().subtract(1,'weeks').toDate(),
          until: moment().toDate()
        },
        report : null,
        page: 0,
        limitOptions
      }
    },
    computed : {
      since(){
        return moment(this.dates.since).format('YYYY-MM-DD');
      },
      until(){
        return moment(this.dates.until).format('YYYY-MM-DD');
      },
      ...mapState('zones',['zones']),
      ...mapState('partners', ['config'])
    },
    watch : {
      filters : {
        deep: true,
        handler(newVal, oldVal){
          this.setRouteQuery();
          //if(!_.isEqual(newVal, oldVal))
          this.doSearch();
        }
      }
    },
    created() {
      if(this.$route.query.since){
        this.dates.since = moment(this.$route.query.since).toDate();
      }
      if(this.$route.query.until){
        this.dates.until = moment(this.$route.query.until).toDate();
      }
      this.filters = {
        limit: '20',
        ...this.$route.query,
        page: this.$route.query.page ? Number(this.$route.query.page) : 1,
        since: this.since,
        until : this.until,
        zone_id: this.$route.query.zone_id ? this.$route.query.zone_id : ((this.zones.length > 0) ? this.zones[0].id : null)
      };
      this.doSearch = _.debounce(this.getItems,300);
    },
    mounted: {
      
    },
    methods : {
      ...mapActions('partners',['fetchRoutesReport','fetchRoutesReportWeekly','getConfig']),
      setRouteQuery(){
        let query = {...this.filters, page: `${this.filters.page}`};
        if(!_.isEqual(query, this.$route.query)){
          try{
            this.$router.push({query: query});
          }catch(error){

          }
        }
      },
      updateDateQuery(){
        this.page = 1;
        this.filters = {
          ...this.filters,
          page: '1',
          since: this.since,
          until : this.until,
        }
      },
      getItems(){
        this.$vs.loading({type:'point'});
        this.fetchRoutesReport(_.cloneDeep(this.filters))
          .then(data=>{
            this.report = data;
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      },
      updateDateQueryWeekly_from(){
        this.dates.since=this.getMonday(this.dates.since);
        this.dates.until=this.getSunday(this.dates.since);
        this.page = 1;
        this.filters = {
          ...this.filters,
          page: '1',
          since: this.since,
          until : this.until,
        }
      },
      updateDateQueryWeekly_to(){
        this.dates.since=this.getMonday(this.dates.until);
        this.dates.until=this.getSunday(this.dates.until);
        this.page = 1;
        this.filters = {
          ...this.filters,
          page: '1',
          since: this.since,
          until : this.until,
        }
      },
       getMonday(d) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
        return new Date(d.setDate(diff));
      },
       getSunday(d) {
        d = new Date(d);
        var day = d.getDay(),
            diff = d.getDate() + (day == 0 ? 0:(7-day)  ); // adjust when day is sunday
        return new Date(d.setDate(diff));
      },
      download_weekly(){
        this.$vs.loading({type:'point'});
        this.fetchRoutesReportWeekly({
          since: this.since,
          until : this.until,
          export: true,
          format: 'xlsx'
        })
          .then(data=>{
            FileDownload(data, `routes-${this.since}-${this.until}.xlsx`);
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })

      },
      download(){
        this.$vs.loading({type:'point'});
        this.fetchRoutesReport({
          since: this.since,
          until : this.until,
          export: true,
          format: 'csv'
        })
          .then(data=>{
            FileDownload(data, `passengers-${this.since}-${this.until}.csv`);
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      }
    }
  }
</script>

<style scoped>

</style>
